import logoUrl from "../assets/logo.webp";

/** Eurocar Inspect wordmark (white) — for dark surfaces (sidebar, auth screens). */
export function Logo({ className = "" }: { className?: string }) {
  return <img src={logoUrl} alt="Eurocar Inspect" className={className} draggable={false} />;
}
